const ApplicationsSlider = ( $ ) => {
	const blocks = $( '.description-block' );
	if ( ! blocks.length ) {
		return;
	}

	blocks.each( function() {
		const $block = $( this );
		const productSlider = $block.find( '.product-slider' ),
			productSelect = $block.find( '.product-select' ),
			descList = $block.find( '.desc-list' );

		const updateContent = ( slick, currentSlide ) => {
			console.log( 'Updating content for slide:', currentSlide );
			const currentSlideElem = $( slick.$slides[ currentSlide ] );
			console.log( 'Current slide element:', currentSlideElem[0] );

			// Try to get from data attribute or data() on the slide or its children
			let title = currentSlideElem.attr( 'data-title' ) || currentSlideElem.data( 'title' );
			let description = currentSlideElem.attr( 'data-description' ) || currentSlideElem.data( 'description' );

			// If not found on the slide itself, look inside (sometimes Slick wraps)
			if ( ! title ) {
				const innerItem = currentSlideElem.find( '[data-title]' );
				title = innerItem.attr( 'data-title' ) || innerItem.data( 'title' );
				description = innerItem.attr( 'data-description' ) || innerItem.data( 'description' );
				console.log( 'Looked inside - Title:', title );
			}
			console.log( 'Data found - Title:', title, 'Description:', description );

			const mainTitle = $block.find( '.main-slider-title' ),
				mainDesc = $block.find( '.main-slider-desc' );

			console.log( 'Targets - mainTitle:', mainTitle[0], 'mainDesc:', mainDesc[0] );

			if ( title ) {
				mainTitle.addClass( 'animate__fadeIn' ).html( title );
				console.log( 'Applied Title:', title );
			}
			if ( description ) {
				mainDesc.addClass( 'animate__fadeIn' ).html( description );
				console.log( 'Applied Description:', description );
			}

			// Update select
			productSelect.val( currentSlide );
			if ( productSelect.data( 'selectric' ) ) {
				productSelect.selectric( 'refresh' );
			}

			// Update list
			descList.find( 'li' ).removeClass( 'active' );
			descList.find( `li[data-index="${currentSlide}"]` ).addClass( 'active' );

			setTimeout( () => {
				mainTitle.removeClass( 'animate__fadeIn' );
				mainDesc.removeClass( 'animate__fadeIn' );
			}, 1000 );
		};

		productSlider.on( 'init', function( event, slick ) {
			console.log( 'Slider init event' );
			updateContent( slick, 0 );
		} );

		productSlider.on( 'afterChange', function( event, slick, currentSlide ) {
			console.log( 'Slider afterChange event, new slide:', currentSlide );
			updateContent( slick, currentSlide );
		} );

		// If already initialized
		if ( productSlider.hasClass( 'slick-initialized' ) ) {
			console.log( 'Slider already initialized, triggering update' );
			const slick = productSlider.slick( 'getSlick' );
			updateContent( slick, slick.currentSlide );
		}

		productSelect.on( 'change', function() {
			const index = $( this ).val();
			if ( index !== '' ) {
				productSlider.slick( 'slickGoTo', parseInt( index ) );
			}
		} );

		descList.on( 'click', 'li', function() {
			const index = $( this ).data( 'index' );
			productSlider.slick( 'slickGoTo', parseInt( index ) );
		} );
	} );
};

export default ( ( $ ) => $( ApplicationsSlider ) )( jQuery );
